import Vue from 'vue'
import Router from 'vue-router'
import Index    from '@/components/index'
import BankIndex    from '@/components/index/bank-index'
import CepingIndex from  '@/components/ceping/index'
import CpResult from  '@/components/ceping/result'
import Login from  '@/components/login'
import Newble from '@/components/route/bank-newble'
import Expert from  '@/components/route/bank-expert'
import Elitev2 from  '@/components/route/bank-Elite-v2'
import Elite from  '@/components/route/bank-elite'
import Lombard from  '@/components/route/bank-lombard'
import ResetPwd from '@/components/reset-pwd'
import Popup from '@/components/Popup'
import DoPaper from '@/components/exam/do-paper'
import Course from '@/components/Course'
import PaperAnalysis from '@/components/exam/paper-analysis'
import personal from '@/components/personal/personal'
import certification from '@/components/personal/certification'
import bar from '@/components/tab-bar/bar'
import layer from '@/components/tab-bar/layer'
import MyPaper from '@/components/personal/my-paper'
import amend from '@/components/personal/amend'
import prosperity from '@/components/personal/prosperity'
import breviary from '@/components/thumbnail/breviary.vue'
Vue.use(Router)
export default new Router({
  routes: [
      //首页
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    //个人中心
    {
      path: '/personal',
      name: 'personal',
      component: personal
    },
      //应行业首页
    {
      path: '/bank-index',
      name: 'BankIndex',
      component: BankIndex
    },
      //测评答题页面
    {
      path: '/ceping',
      name: 'CepingIndex',
      component: CepingIndex
    },
      //测评结果页面
    {
      path: '/cp-result',
      name: 'CpResult',
      component: CpResult
    },
      // 财富新人页面
      {
          path: '/Newble',
          name: 'Newble',
          component: Newble,
          props: {levelNum : 1},
          meta: {
              title: '财富新人'
          }
      },
      // 财富达人页面
      {
          path: '/Expert',
          name: 'Expert',
          component: Expert,
          props: {levelNum : 2},
          meta: {
              title: '财富达人'
          }
      },
      // 财富精英页面 根据用户id单独处理
      {
          path: '/Elitev2',
          name: 'Elitev2',
          component: Elitev2,
          props: {levelNum : 3},
          meta: {
              title: '财富精英'
          }
      },
      // 财富精英页面
      {
          path: '/Elite',
          name: 'Elite',
          component: Elite,
          props: {levelNum : 3},
          meta: {
              title: '财富精英'
          }
      },
      // 私人银行家页面
      {
          path: '/Lombard',
          name: 'Lombard',
          component: Lombard,
          props: {levelNum : 4},
          meta: {
              title: '私人银行家'
          }
      },
    // 登录页
     {
       path: '/login',
       name: 'Login',
       component: Login
    },

     // 弹窗页面
    {
      path: '/Popup',
      name: 'Popup',
      component: Popup,
      },
    {
       path: '/reset-pwd',
       name: 'ResetPwd',
       component: ResetPwd
    },
    {
      path: '/do-paper',
      name: 'DoPaper',
      component: DoPaper
    },

    // 我的课程
    {
      path: '/Course',
      name: 'Course',
      component: Course,
      meta: { keepAlive: false }
    },
    {
      path: '/paper-analysis',
      name: 'PaperAnalysis',
      component: PaperAnalysis

    },
    //实名认证
    {
      path: '/personal',
      name: 'personal',
      component: personal

    },
    {
      path: '/certification',
      name: 'certification',
      component: certification

    },
    //导航
    {
      path: '/bar',
      name: 'bar',
      component: bar
    },
    //弹层
    {
      path: '/layer',
      name: 'layer',
      component: layer
    },
      //我的作业
     {
       path: '/my-paper',
       name: 'MyPaper',
       component: MyPaper
     },
     // 修改密码
    {
      path: '/amend',
      name: 'amend',
      component: amend
    },
    //密码修改成功
    {
      path: '/prosperity',
      name: 'prosperity',
      component: prosperity
    },
    // 路线
    {
      path: '/breviary',
      name: 'breviary',
      component: breviary
    }
    ],

   mode: "history"
})



// WEBPACK FOOTER //
// ./src/router/index.js